module.exports = __webpack_public_path__ + "assets/3856e9f30d90209cc5e66f6c1f042307.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/randWilds/WolfHowlTrigger.mp3
 ** module id = 379
 ** module chunks = 0
 **/